// Caps how many grid-card video thumbnails load at once. Cards whose thumbnail is a video file
// (Erome etc.) used to all fetch metadata the moment they mounted, competing with each other
// (and with the post the user actually opens) for a throttled source. Slots are handed out in
// request order; a card releases its slot once it has loaded (or timed out).
const MAX_CONCURRENT = 4

let active = 0
const waiting: Array<() => void> = []

export function acquireGridVideoSlot(): Promise<() => void> {
  return new Promise((resolve) => {
    const grant = () => {
      active++
      let released = false
      resolve(() => {
        if (released) return
        released = true
        active--
        const next = waiting.shift()
        if (next) next()
      })
    }
    if (active < MAX_CONCURRENT) grant()
    else waiting.push(grant)
  })
}
